module.exports = __webpack_public_path__ + "img/multiplier_2.7c03e2ba.png";